// src/components/AccountMenu/AccountMenu.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AccountMenu.css';

const AccountMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
    closeMenu();
  };

  const handleNavigation = (path) => {
    navigate(path);
    closeMenu();
  };

  return (
    <div className="account-menu-container">
      <button onClick={toggleMenu} className="account-menu-button">
        account
      </button>
      
      {isOpen && (
        <div className="account-menu-dropdown">
          {user ? (
            <>
              <button onClick={() => handleNavigation('/favorites')}>
                favorites
              </button>
              <button onClick={() => handleNavigation('/profile')}>
                profile
              </button>
              <button onClick={handleLogout}>
                sign out
              </button>
            </>
          ) : (
            <>
              <button onClick={() => handleNavigation('/login')}>
                sign in
              </button>
              <button onClick={() => handleNavigation('/signup')}>
                sign up
              </button>
            </>
          )}
        </div>
      )}
      
      {isOpen && (
        <div className="menu-backdrop" onClick={closeMenu}></div>
      )}
    </div>
  );
};

export default AccountMenu;